module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('Loading', {
    attrs: {
      "is-loading": ""
    }
  }) : [_c('h1', {
    staticClass: "persona-view-header"
  }, [_vm._v("\n      Excuse us for jumping in... we have a quick question. Don’t worry, we won’t ask again.\n    ")]), _vm._v(" "), _c('h3', [_vm._v("How would you best describe your role?")]), _vm._v(" "), _c('div', {
    staticClass: "persona-view-radio-group",
    attrs: {
      "role": "radiogroup",
      "aria-label": 'Select your default project view'
    }
  }, _vm._l((_vm.personasList), function(persona, index) {
    return _c('div', {
      key: ("persona-view-option-" + index),
      ref: ("persona-view-option-" + index),
      refInFor: true,
      staticClass: "persona-view__item",
      class: {
        'persona-view__item--selected': persona.value === _vm.selectedPersona
      },
      attrs: {
        "role": "radio",
        "aria-checked": persona.value === _vm.selectedPersona,
        "tabindex": "0",
        "aria-label": persona.description,
        "data-identifier": persona.value
      },
      on: {
        "click": function($event) {
          return _vm.onSelect(persona.value)
        },
        "keyup": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.onSelect(persona.value)
        }
      }
    }, [_c('div', {
      staticClass: "persona-view-icon-wrapper",
      class: {
        'persona-view__item-text--selected': persona.value === _vm.selectedPersona
      }
    }, [(persona.value === _vm.selectedPersona) ? _c('img', {
      staticClass: "persona-view__item-check",
      attrs: {
        "src": _vm.checkIcon
      }
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "persona-view__item-icon",
      attrs: {
        "src": persona.icon
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "persona-view__item-text"
    }, [_vm._v(_vm._s(persona.label))]), _vm._v(" "), _c('label', {
      staticClass: "persona-view__item-text-description"
    }, [_vm._v(_vm._s(persona.description))])])])
  }), 0), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "persona-view-info"
  }, [_vm._v("\n      We use this information to personalize your\n      experience, tailoring it to suit your needs perfectly.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "persona-view__actions"
  }, [_c('button', {
    staticClass: "w-button w-button--blue persona-view__submit",
    attrs: {
      "data-identifier": "persona-submit"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_c('span', {
    staticClass: "w-button__label"
  }, [_vm._v("Next")])])])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67e314e6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/PersonaCapture/PersonaCapture.vue
// module id = 603
// module chunks = 1